import { useState } from "react";
import type { CatalogItem } from "../../api/types";

/** The item a paper line is linked to, shown as text with a "Change" that opens the full picker. */
export function LineItemPicker({
  lineId,
  itemId,
  items,
  onPick,
  pickLabel = "Pick an existing item",
}: {
  lineId: string;
  itemId: string;
  items: CatalogItem[];
  onPick: (itemId: string) => void;
  /** The button text when no item is linked yet. */
  pickLabel?: string;
}) {
  // The catalogue runs to thousands of items; a <select> per line is only
  // mounted while someone is choosing, never for every line at once.
  const [open, setOpen] = useState(false);
  const current = itemId ? items.find((i) => i.id === itemId) : undefined;
  if (!open) {
    return (
      <div className="paper-line__item">
        {itemId ? (
          <span>{current ? `${current.name}${current.sku ? ` (${current.sku})` : ""}` : itemId}</span>
        ) : null}
        <button type="button" className="button plain" onClick={() => setOpen(true)}>
          {itemId ? "Change" : pickLabel}
        </button>
      </div>
    );
  }
  return (
    <div className="paper-line__item">
      <select
        id={`item-${lineId}`}
        aria-label="Catalogue item"
        value={itemId}
        autoFocus
        onChange={(e) => {
          onPick(e.target.value);
          setOpen(false);
        }}
      >
        <option value="">— Select item —</option>
        {items.map((it) => (
          <option key={it.id} value={it.id}>
            {it.name}
            {it.sku ? ` (${it.sku})` : ""}
          </option>
        ))}
      </select>
      <button type="button" className="button plain" onClick={() => setOpen(false)}>
        Cancel
      </button>
    </div>
  );
}

export function LineZoneSelect({
  lineId,
  zoneId,
  zones,
  onPick,
}: {
  lineId: string;
  zoneId: string;
  zones: Array<{ id: string; name: string }>;
  onPick: (zoneId: string) => void;
}) {
  return (
    <select
      id={`zone-${lineId}`}
      aria-label="Receiving zone"
      value={zoneId}
      onChange={(e) => onPick(e.target.value)}
    >
      <option value="">— Zone —</option>
      {zones.map((z) => (
        <option key={z.id} value={z.id}>
          {z.name}
        </option>
      ))}
    </select>
  );
}
